// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1itazb20 {
  padding: var(--_18w76bwd);
  width: 100%;
  background-color: var(--_18w76bw2w);
  border-radius: var(--_18w76bwb);
}
._1itazb21 {
  padding: var(--_18w76bwb) var(--_18w76bwc);
  line-height: var(--_18w76bw47);
  border-bottom: 1px solid var(--_18w76bw2a);
}
._1itazb21:last-child {
  border-bottom: none;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,WAAW;EACX,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,0CAA0C;EAC1C,8BAA8B;EAC9B,0CAA0C;AAC5C;AACA;EACE,mBAAmB;AACrB","sourcesContent":["._1itazb20 {\n  padding: var(--_18w76bwd);\n  width: 100%;\n  background-color: var(--_18w76bw2w);\n  border-radius: var(--_18w76bwb);\n}\n._1itazb21 {\n  padding: var(--_18w76bwb) var(--_18w76bwc);\n  line-height: var(--_18w76bw47);\n  border-bottom: 1px solid var(--_18w76bw2a);\n}\n._1itazb21:last-child {\n  border-bottom: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
